/** Category nesting helpers (one level of sub-categories). */

export function isTopLevel(cat) {
  return !cat?.parent_slug
}

export function childrenOf(categories, parentSlug) {
  return (categories || [])
    .filter((c) => c.parent_slug === parentSlug)
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
}

export function topLevelCategories(categories) {
  return (categories || [])
    .filter((c) => isTopLevel(c))
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
}

/** Flat list in sidebar / manage order: each parent followed by its children. */
export function orderedCategoryList(categories) {
  const list = categories || []
  const seen = new Set()
  const out = []
  for (const parent of topLevelCategories(list)) {
    out.push(parent)
    seen.add(parent.slug)
    for (const child of childrenOf(list, parent.slug)) {
      out.push(child)
      seen.add(child.slug)
    }
  }
  // Orphans (parent missing) at the end
  const orphans = list
    .filter((c) => !seen.has(c.slug))
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
  return [...out, ...orphans]
}

/** Parents that may accept sub-categories (top-level only; exclude self). */
export function parentOptions(categories, excludeSlug) {
  return topLevelCategories(categories).filter((c) => c.slug !== excludeSlug)
}
